/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import {Col, Card, CardBody, CardHeader, Container, Row, Button} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/

import ApiCalls from '../../custom-classes/api-calls';
import ProfileDataTable from '../datatables/profiles-data-table';
import LanguageManager from '../../custom-classes/language-manager';
import SelectorStudentProduct from "../selectors/selector-student-products";
import ChartAverage from '../charts/chart-average';
import TableTotalLessons from '../tables/table-total-lessons';
import NavbarMobile from '../navbar/navbar-mobile';
import NavbarDesktop from '../navbar/navbar-desktop-top';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChartPie} from '@fortawesome/free-solid-svg-icons';
/**
 * Class/component of the student average
 */
class ReportStudentAverage extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        let languages = [
            {name: "English", code: "en"},
            {name: "Español", code: "es"}
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);

        this.state = {
            productId: null,
            studentId: null,
            languages: languages, // Repeat language here, because we need it to pass it the child to create inline translation
            passedTotal: 0,
            notPassedTotal: 0,
            lessonAverageCompleteInfo: [],
            navbarMobile: false,
            studentFullName: null
        };
        this.showStudentBox = this.showStudentBox.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Call the user details to set everything
     */
    callStudentAnalysis = () => (newValue) => {
        this.setState({productId: newValue}, ()=> {
            // Call the api of student average
            let apiCall = ApiCalls.getStudentAverage(this.state.studentId.value, this.state.productId.value);
            apiCall.then((data)=> {

                let passedTotal = 0;
                let notPassedTotal = 0;
                if (data.AverageWithLessonResultDetails != null) {
                    passedTotal = parseFloat(data.AverageWithLessonResultDetails.Average);
                    notPassedTotal = parseFloat(100 - parseFloat(data.AverageWithLessonResultDetails.Average)).toFixed(2);
                }
                this.setState({
                    passedTotal: passedTotal,
                    notPassedTotal: notPassedTotal,
                    lessonAverageCompleteInfo: data.LessonAverageCompleteInfoResponseList
                });
            });
        });
    };

    /**
     * Call the student classes
     */
    callStudentProducts = () => (newValue) => {
        this.setState({studentId: newValue, productId: null, studentFullName: newValue.GivenName + ' ' + newValue.Surname});
    };

    showStudentBox(){
        this.setState({
            studentId: null,
            productId: null
        });
    }
    /**
     * Render the form details
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faChartPie}/>{' '}
                            <Translate id="navbar.student-average" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                        <Row>
                            <Col sm={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}>
                                <Card className="card-blue-transparency">
                                    <CardHeader>
                                        <h4 className="white-text">
                                            <Translate id="report-student-average.student-average"
                                                       options={{renderInnerHtml: false}}/>
                                        </h4>
                                        <small>
                                            <Translate id="report-student-average.student-average-instructions"
                                                       options={{renderInnerHtml: false}}/>
                                        </small>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            {
                                                this.state.studentId === null || this.state.studentId === '' ?
                                                <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                                    <p><b><Translate id="report-student-average.select-student"
                                                                     options={{renderInnerHtml: true}}/></b></p>
                                                    <ProfileDataTable updateParent={this.callStudentProducts()}/>
                                                </Col> : null
                                            }
                                        </Row>
                                        <Row>
                                            {
                                                this.state.studentId !== null && this.state.studentId !== '' ?
                                                    <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                                        <Translate id="report-student-average.selected-student"
                                                                   options={{renderInnerHtml: false}}/>
                                                        : <span className="yellow-text"><b> {this.state.studentFullName} </b></span> {' '}

                                                        <Button color="warning" onClick={this.showStudentBox}>
                                                            <Translate id="report-student-average.select-a-student"
                                                                       options={{renderInnerHtml: false}}/>
                                                        </Button>
                                                    </Col> : null
                                            }
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}>
                                <Card className="card-blue-transparency">
                                    <CardHeader>
                                        <h4 className="white-text">
                                            <Translate id="report-student-average.class"
                                                       options={{renderInnerHtml: false}}/>
                                        </h4>
                                        <small>
                                            <Translate id="report-student-average.class-instructions"
                                                       options={{renderInnerHtml: false}}/>
                                        </small>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                                <p><b><Translate id="report-student-average.select-class"
                                                                 options={{renderInnerHtml: true}}/></b></p>
                                                { this.state.studentId !== null ?
                                                    <div className="gray-dark-text">
                                                        <SelectorStudentProduct data={this.state}
                                                                            updateParent={this.callStudentAnalysis()}/>
                                                    </div>
                                                    : null }
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}}>
                                {
                                    this.state.passedTotal !== 0
                                    && this.state.notPassedTotal !== 0 ?
                                        <Card className="card-darker-transparency">
                                            <CardHeader>
                                                <h4 className="white-text">
                                                    <Translate id="report-student-average.student-average"
                                                               options={{renderInnerHtml: false}}/>
                                                </h4>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                                        { this.state.studentId !== null
                                                        && this.state.productId !== null
                                                        && this.state.passedTotal !== 0
                                                        && this.state.notPassedTotal !== 0 ?
                                                            <ChartAverage data={this.state}
                                                                          updateParent={this.callStudentAnalysis()}/> : null }
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        : null }
                            </Col>

                        </Row>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}}>
                                <Card className="card-darker-transparency">
                                    <CardHeader>
                                        <h4 className="white-text">
                                            <Translate id="report-student-average.average-lesson"
                                                       options={{renderInnerHtml: false}}/>
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                                {
                                                    this.state.productId !== null &&
                                                    this.state.lessonAverageCompleteInfo !== null &&
                                                    typeof this.state.lessonAverageCompleteInfo !== 'undefined' &&
                                                    this.state.lessonAverageCompleteInfo.length > 0 ?
                                                        <TableTotalLessons data={this.state}/> : null }
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>
        )
    };
}

export default withLocalize(ReportStudentAverage);